 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_FRONTISPIECE from '@/components/html/01_Frontispiece'
 import HTML04_CONTENTS from '@/components/html/04_CONTENTS'
 import HTML05_IMAGE from '@/components/html/05_Image'
 import HTML06_PREFACE from '@/components/html/06_Preface'
 import HTML07_THE_WORLD__KEY_LOCATIONS_VISITED from '@/components/html/07_The_World__key_locations_visited'
 import HTML08_BEFORE_WE_GO from '@/components/html/08_Before_We_Go'
 import HTML09_1__ON_A_TRIP_TO_IKEA from '@/components/html/09_1__On_a_Trip_to_IKEA'
 import HTML10_2__VAMPIRE_HUNTING from '@/components/html/10_2__Vampire_Hunting'
 import HTML11_3__DRAGON_SLAYING from '@/components/html/11_3__Dragon_Slaying'
 import HTML12_4__THROUGH_HOLY_LAND from '@/components/html/12_4__Through_Holy_Land'
 import HTML13_5__ON_SACRED_SLOPES from '@/components/html/13_5__On_Sacred_Slopes'
 import HTML14_6__ACROSS_KINGDOMS from '@/components/html/14_6__Across_Kingdoms'
 import HTML15_7__TO_PITCHER_PLANT_PARADISE from '@/components/html/15_7__To_Pitcher_Plant_Paradise'
 import HTML16_ACKNOWLEDGEMENTS from '@/components/html/16_Acknowledgements'
 import HTML17_NOTES from '@/components/html/17_Notes'
 import HTML18_INDEX_OF_PLANTS from '@/components/html/18_Index_of_plants'
 import HTML19_INDEX_OF_PLACES from '@/components/html/19_Index_of_places'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_CONTENTS",
 			"name" : "html/04_CONTENTS",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Image",
 			"name" : "html/05_Image",
 			"component" : HTML05_IMAGE
 		},
 		{
 			"path" : "/html/06_Preface",
 			"name" : "html/06_Preface",
 			"component" : HTML06_PREFACE
 		},
 		{
 			"path" : "/html/07_The_World__key_locations_visited",
 			"name" : "html/07_The_World__key_locations_visited",
 			"component" : HTML07_THE_WORLD__KEY_LOCATIONS_VISITED
 		},
 		{
 			"path" : "/html/08_Before_We_Go",
 			"name" : "html/08_Before_We_Go",
 			"component" : HTML08_BEFORE_WE_GO
 		},
 		{
 			"path" : "/html/09_1__On_a_Trip_to_IKEA",
 			"name" : "html/09_1__On_a_Trip_to_IKEA",
 			"component" : HTML09_1__ON_A_TRIP_TO_IKEA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js